export default __webpack_public_path__ + "static/screen_history@2x-acb9b14e738455477aa81c7cb9158029.jpg";